module.exports = __webpack_public_path__ + "img/tree-02-d-trunk.cda44f53.png";